import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Mail, Clock, Phone, MessageCircle } from 'lucide-react';
import { businessInfo } from '../mock/data';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[var(--dark-card)] border-t border-gray-800">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Logo & About */}
          <div className="space-y-4">
            <img
              src={businessInfo.logo}
              alt={businessInfo.name}
              className="h-16 w-auto object-contain"
            />
            <p className="text-gray-400 text-sm leading-relaxed">
              Geleneksel Türk hamamı, profesyonel masaj ve spa hizmetleri ile bedeninize ve ruhunuza huzur.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-[var(--gold)] font-bold mb-4 font-['Playfair_Display']">Hızlı Bağlantılar</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-gray-400 hover:text-[var(--gold)] transition-colors duration-300 text-sm">
                  Ana Sayfa
                </Link>
              </li>
              <li>
                <Link to="/hizmetler" className="text-gray-400 hover:text-[var(--gold)] transition-colors duration-300 text-sm">
                  Hizmetler
                </Link>
              </li>
              <li>
                <Link to="/galeri" className="text-gray-400 hover:text-[var(--gold)] transition-colors duration-300 text-sm">
                  Galeri
                </Link>
              </li>
              <li>
                <Link to="/iletisim" className="text-gray-400 hover:text-[var(--gold)] transition-colors duration-300 text-sm">
                  İletişim
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-[var(--gold)] font-bold mb-4 font-['Playfair_Display']">İletişim</h3>
            <ul className="space-y-3">
              <li className="flex items-start space-x-3">
                <MapPin size={18} className="text-[var(--gold)] mt-1 flex-shrink-0" />
                <span className="text-gray-400 text-sm">{businessInfo.address}</span>
              </li>
              <li className="flex items-start space-x-3">
                <Phone size={18} className="text-[var(--gold)] mt-1 flex-shrink-0" />
                <div className="space-y-2">
                  {businessInfo.phones.map((phone, index) => (
                    <div key={index} className="flex items-center space-x-3">
                      <a
                        href={`tel:${phone.replace(/\s/g, '')}`}
                        className="text-gray-400 hover:text-[var(--gold)] transition-colors duration-300 text-sm"
                        onClick={() => window.gtag_report_conversion && window.gtag_report_conversion(`tel:${phone.replace(/\s/g, '')}`)}
                      >
                        {phone}
                      </a>
                      <a
                        href={`https://wa.me/${phone.replace(/\s/g, '').replace(/\+/g, '')}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-[#25D366] hover:text-[#20BA5A] transition-colors duration-300"
                        title="WhatsApp"
                      >
                        <MessageCircle size={16} />
                      </a>
                    </div>
                  ))}
                </div>
              </li>
              <li className="flex items-start space-x-3">
                <Mail size={18} className="text-[var(--gold)] mt-1 flex-shrink-0" />
                <span className="text-gray-400 text-sm">{businessInfo.email}</span>
              </li>
            </ul>
          </div>

          {/* Hours */}
          <div>
            <h3 className="text-[var(--gold)] font-bold mb-4 font-['Playfair_Display']">Hizmet Saatleri</h3>
            <div className="flex items-start space-x-3">
              <Clock size={18} className="text-[var(--gold)] mt-1 flex-shrink-0" />
              <div className="text-gray-400 text-sm">
                <p className="font-semibold text-[var(--gold-light)]">Pazartesi hariç her gün</p>
                <p className="mt-1">11:00 - 22:00</p>
              </div>
            </div>
            <div className="mt-4 p-3 bg-[var(--dark-bg)] rounded-lg border border-[var(--gold-dark)]">
              <p className="text-xs text-gray-400 leading-relaxed">
                <span className="text-[var(--gold)] font-semibold">Not:</span> Randevu almak için lütfen önceden iletişime geçiniz.
              </p>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-gray-800">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-gray-500 text-sm">
              &copy; {currentYear} {businessInfo.name}. Tüm hakları saklıdır.
            </p>
            <div className="flex items-center space-x-6">
              <a href="#" className="text-gray-400 hover:text-[var(--gold)] transition-colors duration-300 text-sm">
                Gizlilik Politikası
              </a>
              <a href="#" className="text-gray-400 hover:text-[var(--gold)] transition-colors duration-300 text-sm">
                Kullanım Koşulları
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;